export const FIELD_TYPES = {
  TEXT: "text",
  TEXTAREA: "textarea",
  NUMBER: "number",
  DATE: "date",
  DATETIME: "datetime",
  SELECT: "select",
  MULTISELECT: "multiselect",
  CHECKBOX: "checkbox",
  RADIO: "radio",
  SLIDER: "slider",
  TABLE: "table",
  FILE: "file",
  SECTION_HEADER: "section_header",
};

export const SELECTABLE_TYPES = [
  FIELD_TYPES.SELECT,
  FIELD_TYPES.MULTISELECT,
  FIELD_TYPES.RADIO,
  FIELD_TYPES.CHECKBOX,
];

export const PATIENT_MODES = [
  { label: "IP", value: "IP" },
  { label: "OP", value: "OP" },
  { label: "Both", value: "BOTH" },
];

export const MAX_FORMS_PER_MODE = 5;
export const MAX_NESTING_DEPTH = 4;
export const MAX_HEADING_LENGTH = 60;

/** Letters, numbers, and spaces only — used for section names. */
export const ALPHANUMERIC_WITH_SPACES = /^[A-Za-z0-9 ]+$/;
/** Letters, numbers, spaces, and parentheses — used for form names. */
export const ALPHANUMERIC_WITH_PARENS = /^[A-Za-z0-9 ()]+$/;

export const sanitizeAlphanumericName = (text = "") =>
  String(text).replace(/[^A-Za-z0-9 ]/g, "");

export const sanitizeFormName = (text = "") =>
  String(text).replace(/[^A-Za-z0-9 ()]/g, "");
